define('lib/shouldUseOverlay',[],function () {

  var itemRouteMatchers = [
    /\/[^\/]+\/[^\/]+\/apps\/new$/, // Create new item
    /\/[^\/]+\/[^\/]+\/apps\/[^\/]+\/edit$/, // Template editor
    /\/[^\/]+\/[^\/]+\/apps\/[^\/]+\/settings$/, // App settings
    /\/[^\/]+\/[^\/]+\/apps\/[^\/]+\/dashboard$/, // Report overlay
    /\/[^\/]+\/[^\/]+\/apps\/[^\/]+\/items\/(?:[\d]+)$/ // Item
  ];

  return function(url) {
    return itemRouteMatchers.some(function (matcher) {
      return matcher.test(url);
    });
  }

});

